import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationState {
  currentPath: string;
}

const initialState: NavigationState = {
  currentPath: '/',
};

export const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCurrentPath: (state, action: PayloadAction<string>) => {
      state.currentPath = action.payload;
    },
    clearNavigation: () => initialState,
  },
});

export const { setCurrentPath, clearNavigation } = navigationSlice.actions;
export default navigationSlice.reducer;
